import { render, staticRenderFns } from "./DrivinginfoComponent.vue?vue&type=template&id=388fff35"
import script from "./DrivinginfoComponent.vue?vue&type=script&lang=js"
export * from "./DrivinginfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports